// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';
import maskInput from '../../../../utils/maskInput';
import { trimCommas } from '../../../../utils/commonUtils';
import dayjs from 'dayjs';

export default class IndexView extends JQueryView {
  constructor() {
    super('.simple_form');

    this.renderInvestorArea();
    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '.add-investor-button' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.add-investor-wrapper').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderInvestorArea();
    this.render();
  }

  @on({ event: 'click', selector: '.remove-button' })
  onClickRemoveFields(event: any) {
    const _destroy = $(event.target)
      .parents('fieldset')
      .find('._destroy');
    _destroy.val('1');
    _destroy.closest('fieldset').hide();
    event.preventDefault();
    this.renderInvestorArea();
  }

  @on({ event: 'change', selector: 'input' })
  changeInput() {
    const cancelButton = $('#fund-button-fields .submit-button');
    const newButton = $(
      '<button type="button" class="btn c-button--orange-outline" data-toggle="modal" data-target="#cancel_modal">キャンセル</button>',
    );

    cancelButton.replaceWith(newButton);
  }

  @on({ event: 'click', selector: '.check-amounts' })
  onClickCalculateAndSubmit(event: any) {
    const editingForm = $(event.target).closest($('.simple_form'));
    // フォームのIDを取得しsubmitボタンに設定
    const formId = editingForm.attr('id');
    $('#modal-submit-button').attr('form', formId);

    this.trimCommasFromValue();

    // 合計額を計算して分岐する(investorがなければ計算しない)
    if ($(editingForm).find($('.investor-form')).length) {
      if (this.calcInvestmentAmount(editingForm)) {
        $('#modal-submit-button').trigger('click');
      } else {
        $('#confirm_modal').modal();
      }
    } else {
      $('#modal-submit-button').trigger('click');
    }
  }

  // 金額のカンマを除去する処理
  trimCommasFromValue() {
    $('.currency').each((index, element) => {
      $(element).val(trimCommas($(element).val()));
    });
  }

  calcInvestmentAmount(form: any) {
    // 出資総額と出資額の合計を比較。カンマ付きの文字列を数値に変換
    const fundTotalInvestmentAmount = parseInt(
      form
        .find($('.total-investment-amount'))
        .val()
        .replace(/,/g, '') || 0,
    );
    let investorTotalInvestmentAmount = 0;
    form.find($('.investment-amount')).each(function(index, investor) {
      investorTotalInvestmentAmount += parseInt(
        $(investor)
          .val()
          .replace(/,/g, '') || 0,
      );
    });
    return fundTotalInvestmentAmount === investorTotalInvestmentAmount;
  }

  renderInvestorArea() {
    const maxCount = 100;
    if ($('fieldset:visible').length >= maxCount) {
      $('.add-investor-button').hide();
    } else {
      $('.add-investor-button').show();
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
    maskInput();
  }
}
